import { IconButtonProps } from '@rjsf/utils';
import { ChevronUp } from 'lucide-react';
import { Button } from '../../Button';

export const ShMoveUpButtom = (props: IconButtonProps) => (
  <Button
    variant="ghost"
    size="icon"
    onClick={props.onClick}
    disabled={props.disabled}
    title="Move item up"
    className="ml-2"
  >
    <ChevronUp className="h-4 w-4" />
  </Button>
);
